var render = function render(){var _vm=this,_c=_vm._self._c;return _c('treeselect',{ref:"treeselect",attrs:{"disabled":_vm.deactivated,"multiple":_vm.multiple,"options":_vm.tags,"show-count":true,"showCountOf":"LEAF_DESCENDANTS","placeholder":_vm.placeholder
      ? _vm.placeholder
      : _vm.multiple
      ? 'Select one or more tags'
      : 'Select a single tag',"disable-branch-nodes":!_vm.multiple,"flatten-search-results":true,"value-consists-of":"LEAF_PRIORITY"},scopedSlots:_vm._u([{key:"value-label",fn:function({ node }){return _c('div',{},[_vm._v(_vm._s(node.raw.label))])}}]),model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }